import { render, staticRenderFns } from "./SearchInput.vue?vue&type=template&id=16253143&"
import script from "./SearchInput.vue?vue&type=script&lang=js&"
export * from "./SearchInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QInput,QIcon} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QInput,QIcon})
